import { SectionIds } from '@modeso/aumico-lib-annualreport-fe';
import { PrintLocation } from '@modeso/types__aumico-lib-annualreport-be';

export interface IComplementaryReportIdLocationSortOrder {
    id: SectionIds;
    sortOrderId: number;
    printLocation: PrintLocation;
}
